import {create} from 'zustand'

type InternalConversationsStore = {
    isOpen: boolean
    initialConversationId: string | null
    open: (conversationId?: string) => void
    close: () => void
    clearInitialConversation: () => void
}

/**
 * Global UI state for the internal conversations drawer (conversations without a patient).
 * Opened from the account menu entry or from a conversation notification without a link.
 * Not persisted: the drawer always starts closed on a fresh session.
 */
export const useInternalConversationsStore = create<InternalConversationsStore>()(set => ({
    isOpen: false,
    initialConversationId: null,
    // Re-invoking open with a different id while already open switches the focused conversation
    open: conversationId => set({isOpen: true, initialConversationId: conversationId ?? null}),
    close: () => set({isOpen: false, initialConversationId: null}),
    clearInitialConversation: () => set({initialConversationId: null})
}))
